import { BaseModel } from './BaseModel';

export class SsoLoginFailure extends BaseModel {
    public id = -1;
    public reason = '';
    public email: string | null = null;
    public externalId: string | null = null;
    public exceptionClass: string | null = null;
    public exceptionMessage: string | null = null;
    public ip: string | null = null;
    public userAgent: string | null = null;
    public context: Record<string, unknown> | null = null;
    public createdAt: string | null = null;
}
